// Configuração para controle de analytics
export const ANALYTICS_CONFIG = {
  // Rate limiting - configurações RELAXADAS para permitir Goals
  RATE_LIMIT: {
    maxEvents: 25,         // AUMENTADO para 25 eventos - crítico para Goals
    windowMs: 60000,       // Aumentado para 60 segundos
    cooldownMs: 2000,      // Reduzido para 2 segundos apenas
    maxRetries: 1          // Mantido em 1 retry
  },
  
  // Controle de ambiente
  ENVIRONMENT: {
    enableInDevelopment: true,     // HABILITADO para testar virtual pages
    enableInProduction: true,      // Sempre em produção
    debugMode: process.env.NODE_ENV === 'development'
  },
  
  // Controle de eventos específicos
  EVENTS: {
    // Eventos críticos - sempre enviar (incluindo Goals importantes)
    critical: [
      'Chart Type Selected',
      'Chart Generated', 
      'File Upload',
      'Chart Export',        // ADICIONADO - exports são críticos
      'Button Click',        // ADICIONADO - interações são importantes  
      'Example File Used',   // ADICIONADO - exemplos são importantes
      'pageview'            // Virtual pages são críticas
    ],
    
    // Eventos reduzidos - apenas uma vez por sessão (REDUZIDO)
    sessionOnly: [
      'Section View'
      // 'Button Click' REMOVIDO - queremos track de todos os cliques
    ],
    
    // Eventos desabilitados temporariamente (REDUZIDO - só performance)
    disabled: [
      'Performance'         // Apenas performance desabilitado
      // 'Section Time' REABILITADO
      // 'Validation Error' REABILITADO
    ]
  },
  
  // Limite de eventos por tipo - AUMENTADOS para permitir Goals
  SESSION_LIMITS: {
    pageviews: 20,         // Aumentado para 20 pageviews por sessão
    events: 50,            // AUMENTADO para 50 eventos por sessão - CRÍTICO para Goals
    sections: 15           // Aumentado para 15 seções por sessão
  }
};

// Função para verificar se um evento deve ser enviado
export const shouldSendEvent = (eventName, eventType = 'event') => {
  const config = ANALYTICS_CONFIG;
  
  // Verificar ambiente
  if (process.env.NODE_ENV === 'development' && !config.ENVIRONMENT.enableInDevelopment) {
    return false;
  }
  
  if (process.env.NODE_ENV === 'production' && !config.ENVIRONMENT.enableInProduction) {
    return false;
  }
  
  // Verificar se evento está desabilitado
  if (config.EVENTS.disabled.includes(eventName)) {
    return false;
  }
  
  // Verificar limites de sessão
  const sessionKey = `analytics_${eventType}_count`;
  const currentCount = parseInt(sessionStorage.getItem(sessionKey) || '0');
  const limit = config.SESSION_LIMITS[eventType + 's'] || 10;
  
  if (currentCount >= limit) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(`🚫 Limite de ${eventType}s atingido: ${currentCount}/${limit}`);
    }
    return false;
  }
  
  // Verificar eventos críticos
  if (config.EVENTS.critical.includes(eventName)) {
    return true;
  }
  
  // Verificar eventos de sessão única
  if (config.EVENTS.sessionOnly.includes(eventName)) {
    const sessionEventKey = `analytics_${eventName.replace(/\s+/g, '_').toLowerCase()}_sent`;
    if (sessionStorage.getItem(sessionEventKey)) {
      return false;
    }
    sessionStorage.setItem(sessionEventKey, 'true');
  }
  
  return true;
};

// Função para incrementar contadores de sessão
export const incrementSessionCounter = (eventType) => {
  const sessionKey = `analytics_${eventType}_count`;
  const currentCount = parseInt(sessionStorage.getItem(sessionKey) || '0');
  sessionStorage.setItem(sessionKey, (currentCount + 1).toString());
};

// Função para resetar contadores (para debug)
export const resetAnalyticsCounters = () => {
  const keys = Object.keys(sessionStorage).filter(key => key.startsWith('analytics_'));
  keys.forEach(key => sessionStorage.removeItem(key));
  if (process.env.NODE_ENV === 'development') {
    console.log('🔄 Contadores de analytics resetados');
  }
};

// Log de debug
export const debugAnalytics = () => {
  if (!ANALYTICS_CONFIG.ENVIRONMENT.debugMode) return;
  
  const counters = {};
  Object.keys(sessionStorage).forEach(key => {
    if (key.startsWith('analytics_')) {
      counters[key] = sessionStorage.getItem(key);
    }
  });
  
  if (process.env.NODE_ENV === 'development') {
    console.log('📊 Analytics Debug:', counters);
  }
};
